import { render, staticRenderFns } from "./ApplicationStatusInfoBlock.vue?vue&type=template&id=c56be2c4&"
import script from "./ApplicationStatusInfoBlock.vue?vue&type=script&lang=js&"
export * from "./ApplicationStatusInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports